import Axios from 'axios';
import React, { Component } from 'react'
import { getUser } from '../../../../actions/session'
import { ASSIGN_AGENT_CUSTOMER, GET_AGENTS_LIST, GET_AGENT_AGAINST_USER, LOGIN_URL } from '../../../../config/rest_endpoints';
import { RC_LOAD_LOGIN } from '../../../routers/RouteConstants';
import { Notifications } from '../../../common/notification';
import CustomLoader from '../../../common/loader';
import Select from 'react-select';


export default class AgentTable extends Component {
    constructor(props) {
        super(props)
        this.state = {
            User:getUser(),
            userId:this.props.userId,
            agentsTable:[],
            isGetting:false,
            selectAgent:[],
            selectedAgent:'',
            rawData:{},
            isCheckSelect:false,
            agentCommission:'',
            isEmpty:false,
            checkLog:null,
            selectType:[
                {label:"Profit",value:"profit"},
                {label:"Gross",value:"gross"}
            ],
            selectedType: '',
            selectFreq:[
                {label:"Monthly",value:"monthly"},
                {label:"Weekly",value:"weekly"}
            ],
            selectedFreq: '',
            isLoginURL: false
        }

        this.handleSelectAgent = this.handleSelectAgent.bind(this)
        this.onSubmitAgent = this.onSubmitAgent.bind(this)
        this.onAgentUpdateValue = this.onAgentUpdateValue.bind(this)
        this.handleSelectFreq = this.handleSelectFreq.bind(this)
        this.handleSelectType = this.handleSelectType.bind(this)
    }

    componentDidMount() {
        this.getAgentList()
        this.getAgentData()
    }

    handleSelectAgent(selectedAgent) {
        this.setState({ 
            selectedAgent,
            isCheckSelect:true ,
            agentCommission:selectedAgent.Commission,
            selectedType:{label:selectedAgent.Type,value:selectedAgent.Type},
            selectedFreq:{label:selectedAgent.Freq,value:selectedAgent.Freq}

        });
        console.log(`selectedAgent:`, selectedAgent);
    };

    handleSelectType(selectedType) {
        this.setState({ selectedType});
        console.log(`selectedType:`, selectedType);
        
    };

    handleSelectFreq(selectedFreq) {
        this.setState({ selectedFreq });
        console.log(`selectedFreq:`, selectedFreq);
    };


    onAgentUpdateValue(e) {
        this.setState({[e.target.name]:e.target.value})
    }

    getAgentList() {
        const {User,selectAgent,rawData} = this.state
        var headers = { "Authorization": "Bearer " + User.token };
        Axios.get(`${GET_AGENTS_LIST}`, { headers }).then(res => {
            if (res) {
                let resp = res.data.data;
                console.log(resp)
                for (var key in resp) {
                    let {name,id,phone,type,commission,frequency,active,email} = resp[key]
                    selectAgent.push({
                        label:name,
                        value:id,
                        Phone:phone,
                        Type:type,
                        Commission:commission,
                        Freq:frequency,
                        Status:active,
                        Email:email
                    })
                
                }
                this.setState({selectAgent})
                
            }
            else {
                Notifications.notify("Fetch failed", "error", "errors")
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.setState({ isLoginURL: true })
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting: false
            })
        })
    }

    getAgentData() {
        const {User,userId} = this.state
        console.log('userId :>> ', userId);
        this.setState({isGetting:true})
        var headers = { "Authorization": "Bearer " + User.token };
        Axios.get(`${GET_AGENT_AGAINST_USER}/${userId}/agent`, { headers }).then(res => {
            if (res) {
                console.log('res :>> ', res);
                this.setState({
                    agentsTable: res.data.data,
                    isGetting: false,
                })
            }
            else {
                Notifications.notify("Fetch failed", "error", "errors")
                this.setState({
                    agentsTable:null,
                    isGetting:false
                })
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.setState({ isLoginURL: true })
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                agentsTable: null,
                isGetting: false,
                isLoginURL: false
            })
        })
    }

    onSubmitAgent() {
        const {User,userId,selectedAgent,agentCommission,selectedFreq,selectedType} = this.state
       
        var payload = {
            "name": selectedAgent.label,
            "id":selectedAgent.value,
            "email": selectedAgent.Email,
            "phone": selectedAgent.Phone,
            "commission": agentCommission,
            "type": selectedType.value,
            "frequency": selectedFreq.value,
            "active": selectedAgent.Status
        }
        console.log(payload)
        var headers = { "Authorization": "Bearer " + User.token };
        Axios.post(`${ASSIGN_AGENT_CUSTOMER}/${userId}/agent/${selectedAgent.value}`,payload, { headers }).then(res => {
            if (res) {
                console.log('res :>> ', res);
                this.setState({
                    isCheckSelect:false,
                })
                this.getAgentData()
                Notifications.notify(`Agent ${selectedAgent.label} is assign`, "Assign", "success")
            }
            else {
                Notifications.notify("Fetch failed", "error", "errors")
            }
        }).catch(err => {
            var respErr = err.response.data
            Notifications.notify(respErr.message, "error", "error")
        })
    }

    renderAgentTable() {
        const { agentsTable,isEmpty } = this.state
        console.log(isEmpty)
        var nullData = (
            <div className="ml-4 mt-2">
                <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
                <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
            </div>
        )
        if (agentsTable === null || agentsTable.length === 0  ) {
            return nullData
        }
        else {
            return (
                <tr >
                    <td style={{textAlign:'center'}}>{agentsTable.name}</td>
                    <td style={{textAlign:'center'}}>{agentsTable.commission}</td>
                    <td style={{textAlign:'center'}}>{agentsTable.type}</td>
                    <td style={{textAlign:'center'}}>{agentsTable.frequency === '' ? "N/A" : agentsTable.frequency}</td>
                    <td style={{textAlign:'center'}}>{agentsTable.assignedDate}</td>
                    <td style={{textAlign:'center'}}>{agentsTable.active === false ? <span className="badge badge-danger">false</span> : <span className="badge badge-success">true</span>}</td>
                </tr>
            )

        }
    }
    
    render() {
        const {selectedAgent,selectAgent,agentCommission,agentprofit,agentFreq,selectedFreq,selectFreq,selectedType,selectType} = this.state;
        let checkForm = (
            <div className="row" style={{zIndex:'1'}}>
                <div className="col-md-3">
                    <div className="form-group">
                        <input type="text" className="form-control" name="agentCommission" value={agentCommission} onChange={this.onAgentUpdateValue} placeholder="Commission" />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="form-group">
                        <Select
                            value={selectedFreq}
                            onChange={this.handleSelectFreq}
                            options={selectFreq}
                            placeholder="Select Frequency"
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="form-group">
                        <Select
                            value={selectedType}
                            onChange={this.handleSelectType}
                            options={selectType}
                            placeholder="Select Type"
                        />
                    </div>
                </div>
            </div>
        )
        return (
            <div>
                <div style={{border:'none',borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.08)'}} className="card card-body ">
                    <div className="row" style={{zIndex:'2'}}>
                        <div className="col-md-6">
                            <div className="py-2 mb-1">
                                <Select
                                    value={selectedAgent}
                                    onChange={this.handleSelectAgent}
                                    options={selectAgent}
                                    placeholder="Select Agent"
                                />
                            </div>
                        </div>
                       <div className="col-md-6">
                       <button  type="submit" className="main-button btn btn-success btn-sm mt-2" onClick={this.onSubmitAgent} >Assign <i class="icon-reading ml-1 icon-1x"></i> </button>
                        </div> 
                    </div>
                    {/* row */}
                    {this.state.isCheckSelect ? checkForm : ''}
                    <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer" style={{zIndex:'0'}}>
                        <div className="datatable-header">
                            <div id="DataTables_Table_0_filter" className="dataTables_filter">
                            </div>
                        </div>
                        <div className="datatable-scroll" style={{ overflowX: 'auto' }}>
                            <table style={{border:'1px solid #ddd',borderCollapse:'collapse'}} className="table table-striped  no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                <thead>
                                    <tr className="stickeyHeader">
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Name</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Commission</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Type</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Frequency</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Assigned Date</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Active</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.isGetting ? <CustomLoader /> : this.renderAgentTable()}
                                </tbody>
                            </table>
                        </div>
                        {/* <div className="datatable-footer">
                            <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 1 to 10 of 15 entries</div>
                            <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                        </div> */}
                    </div>
                </div>    
            </div>
        )
    }
}
